// extracted by mini-css-extract-plugin
module.exports = {"container":"DraftClosedDeadline_container__cYb8b","box":"DraftClosedDeadline_box__LrFrU","errorContainer":"DraftClosedDeadline_errorContainer__q41VF"};